import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { BoundingRect } from '@nx-customer-apps/shared/interfaces';
import { ActiveAnchorService } from '@nx-customer-apps/shared/services';
import { projectDetailsOffset } from '@nx-customer-apps/shared/utils';

@Directive({
    selector: '[vpActiveAnchor]',
    standalone: false
})
export class ActiveAnchorDirective {
    private element = inject(ElementRef);
    private activeAnchorService = inject(ActiveAnchorService);

    @HostListener('window:scroll', ['$event']) onScroll() {
        const boundingRect: BoundingRect = this.element.nativeElement.getBoundingClientRect();
        const isElementInTheView = boundingRect.top < projectDetailsOffset && boundingRect.top + boundingRect.height > projectDetailsOffset;
        if (isElementInTheView) {
            this.activeAnchorService.setAnchor({ id: this.element.nativeElement.id, event: 'scroll' });
        }
    }

    @HostListener('document:click', ['$event']) onClick() {
        this.activeAnchorService.checkIfBottomReached();
    }
}
